<template>
  <div class="">
    <div class="">
      <label class="label-standard w-48 mr-12">{{ label }}</label>
    </div>

    <div class="mt-1 text-gray-700" v-if="tooltip != null">
      {{ tooltip }}
    </div>

    <div class="mt-3">
      <InputRadio 
        :name="'input-' + propertyKey" 
        :id="'input-' + propertyKey + '-discuss'" 
        :propertyKey="propertyKey"
        value="0"
        :checked="value != null && value == 0"
        :updateValue="updateValue" />

      <label class="ml-2 mr-8 text-sm" :for="'input-' + propertyKey + '-discuss'">Discuss with broker</label>

      <InputRadio 
        :name="'input-' + propertyKey" 
        :id="'input-' + propertyKey + '-yes'" 
        :propertyKey="propertyKey"
        value="1"
        :checked="value != null && value == 1"
        :updateValue="updateValue" />

      <label class="ml-2 mr-8 text-sm" :for="'input-' + propertyKey + '-yes'">Yes</label>

      <InputRadio 
        :name="'input-' + propertyKey" 
        :id="'input-' + propertyKey + '-no'" 
        :propertyKey="propertyKey"
        value="2"
        :checked="value != null && value == 2"
        :updateValue="updateValue" />

      <label class="ml-2 text-sm" :for="'input-' + propertyKey + '-no'">No</label>
    </div>
  </div>
</template>

<script>
  
  import InputRadio from "@/shared/components/form/InputRadio"

  export default {

    components : {
      InputRadio
    },

    props : {
      label : {
        type    : String,
        required: true
      },

      propertyKey : {
        type    : String, 
        required: true
      },

      value : {
        // type : Number,
        required : false
      },

      updateValue : {
        type    : Function,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      }
    }
  }
</script>